import type { Currency } from "@/Common/Models/Domain/Currency";

export const ONBOARDING_SOURCE = "onboarding";

export interface Plan {
  currency: Currency;
  description: string;
  discount: number;
  id: string;
  initialSessionPrice: number | null;
  isActive: () => boolean;
  isDiscountOnlyForFirstSubscription: boolean;
  isPrivate: boolean;
  isPromo: boolean;
  price: number;
  promoPlanUuid: string | null;
  promoPlanDescription: string | null;
  sessionPrice: number;
  title: string;
  customerPrice: number;
  isPaymentMethodRequired: boolean;
  startAt: number;
  endAt: number;
  videoCalls: number;
  sessionDuration: number;
}
